import { OktaUserInfo } from '@/app/core/auth';
import {
  Box,
  Menu,
  MenuButton,
  Avatar,
  MenuList,
  MenuItem,
  Icon,
  Link,
  useDisclosure,
  CSSObject,
} from '@chakra-ui/react';
import { FaUser, FaSignOutAlt } from 'react-icons/fa/index.js';
import { Link as ReactRouterLink } from 'react-router-dom';

export const UserProfileMenu = () => {
  const { isOpen, onToggle } = useDisclosure();

  const menuLinkProps: CSSObject = {
    _hover: { textDecoration: 'none' },
    _focus: { boxShadow: 'none' },
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    w: 'full',
    flexDirection: 'row',
  };

  return (
    <Box onMouseOver={onToggle} onMouseOut={onToggle}>
      <Menu isOpen={isOpen}>
        <MenuButton bg='white' h={8}>
          <Avatar
            verticalAlign='middle'
            size='sm'
            background='primary'
            color={'white'}
            name={OktaUserInfo.getUserName()}
          />
        </MenuButton>
        <MenuList>
          <MenuItem>
            <Link
              as={ReactRouterLink}
              sx={menuLinkProps}
              to='/user-account/profile'
            >
              <Icon as={FaUser} /> Profile
            </Link>
          </MenuItem>
          <MenuItem>
            <Link as={ReactRouterLink} sx={menuLinkProps} to='/logout'>
              <Icon as={FaSignOutAlt} /> Logout
            </Link>
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};
